import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { breakpoints, media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikitV2/Button';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { DiscardTaskModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../../interwill/containers/ModalContainerV2';

export const DiscardTaskModal: FC<DiscardTaskModalProps> = ({ onDiscard }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'discardTask' });

  const modals = useModalsStore();

  return (
    <ModalContainerV2 pinBottom title={t('title')}>
      <Container>{t('description')}</Container>
      <Buttons>
        <Button size="middle" type="default" onClick={modals.closeModal}>
          {t('btnCancel')}
        </Button>
        <ButtonStyled
          size="middle"
          onClick={() => {
            modals.closeModal();
            onDiscard();
          }}
        >
          {t('btnConfirm')}
        </ButtonStyled>
      </Buttons>
    </ModalContainerV2>
  );
};

const Container = styled.div`
  font-size: 14px;
  padding: 24px 0 32px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;
  width: 100%;

  ${media.md}, ${breakpoints.sm} {
    flex-direction: column-reverse;
    gap: 8px;

    button {
      width: 100%;
    }
  }
`;

const ButtonStyled = styled(Button)`
  &&& {
    background: ${COLORS.systemFlame200};
    color: ${COLORS.white};
    &:hover {
      background: ${COLORS.systemFlame300} !important;
    }
  }
`;
